import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TpDropdownModule } from 'app/components/tp-dropdown/tp-dropdown.module';
import { RobertMappingDropdownComponent } from './robert-mapping-dropdown.component';

/**
 * Hosts the reusable Robert mapping dropdown. Imported by the 4 admin editors (Clients / Users / Languages /
 * Services). FormsModule is required for the standalone `[ngModel]` binding on the inner tp-dropdown.
 */
@NgModule({
    declarations: [RobertMappingDropdownComponent],
    imports: [
        CommonModule,
        FormsModule,
        TpDropdownModule,
        TranslateModule,
    ],
    exports: [
        RobertMappingDropdownComponent,
    ],
})
export class RobertMappingDropdownModule {
}
